import React        from 'react';
import CSSModules   from 'react-css-modules';
import Helmet       from "react-helmet";
import { connect }  from 'react-redux';

import style from './style.scss';

import PageHeader          from '../PageHeader';
import Accordion           from '../Accordion';
import AccordionContent    from '../AccordionContent';
import AccordionTitle      from '../AccordionTitle';
import OrderSummary        from '../OrderSummary';
import BookingOrganisation from '../BookingOrganisation';
import BookingDelegates    from '../BookingDelegates';
import BookingPayment      from '../BookingPayment';
import BookingConfirmation from '../BookingConfirmation';
import AccordionSection    from '../AccordionSection';
import Overlay             from '../Overlay';
import Button              from "../Button";
import BookingSuccess      from "../BookingSuccess";

import classNames           from 'classnames/bind';

import * as paymentActions from '../../actions/payment';

import paymentApi       from '../../services/payment';
import trimmer          from '../../services/trimmer';
import costCalculator   from "../../services/costCalculator";
import navigator        from "../../services/navigator";

import BreadcrumbTrail from "pattern-library/dist/js/components/BreadcrumbTrail";

import * as ReactGA from "react-ga";

const BookingBanner = (props) => {
    if (!props.course)
        return null;

    let className = '';

    if (props.course.type === 'online') {
        className = 'banner-icon--online'
    } else if (props.course.type === 'classroom') {
        className = 'banner-icon--course'
    } else if (props.course.type === 'conference') {
        className = 'banner-icon--conference'
    }

    return (
        <div className={style['booking-banner']}>
            <div className={style[className]} style={{backgroundColor: props.course.module.hex_colour}} />
            <h4 className={style['booking-banner__heading']} style={{color: props.course.module.hex_colour}}>{ props.course.module.name }</h4>
            <h4 className={style['booking-banner__heading']}>{ props.course.name }</h4>
        </div>
    );
};

class BookingPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {orderSummaryScroller: false};

        this._handleScroll = this._handleScroll.bind(this);
    }
    
    componentDidMount() {



        this.setState({orderSummaryScroller: false});

        if(this.props.params.courseId){
            this.props.refreshELearningCourse(this.props.params.courseId);
        } else {
            this.props.refreshEvent(this.props.params.eventId);
        }

        window.addEventListener('scroll', this._handleScroll);
    }

    componentWillUnmount() {

        this.props.resetPaymentPage();
        window.removeEventListener('scroll', this._handleScroll);
    }

    _handleScroll() {

        let height = window.document.body.scrollHeight;

        if(window.pageYOffset > 520) {
            this.setState({orderSummaryScroller: true});
        }
        if(window.pageYOffset <= 520 || window.pageYOffset >= height - 850) {
            this.setState({orderSummaryScroller: false});
        }
    };

    _getOrderSummaryClassNames() {
        const cx = classNames.bind(style);

        return cx({
            'order-summary-container': true,
            'order-summary-container--scroller': this.state.orderSummaryScroller
        });
    }

    _isAccordionOpen(accordionKey) {

        return this.props.openAccordions.includes(accordionKey);
    }

    _processBooking(bookingValues) {

        this.props.hideGlobalCardError();
        this.props.hideGlobalDelegatesError();
        this.props.hideGlobalEventError();

        const showGlobalDelegatesError = this.props.showGlobalDelegatesError;
        const showGlobalCardError      = this.props.showGlobalCardError;
        const showGlobalEventError     = this.props.showGlobalEventError;
        const openProcessingErrorOverlay = this.props.openProcessingErrorOverlay;

        const showBookingSuccess  = this.props.showBookingSuccess;

        return new Promise((resolve, reject) => {

            function processBooking(vals) {
                const booking = this._constructBookingValues(this.props.event, vals, this.props.eLearningCourse);

                return paymentApi.processBooking(trimmer.trim(booking))
                    .then(() => bookingSuccess(this._getCostBreakdown().total), bookingFailed);
            }

            processBooking = processBooking.bind(this);

            function bookingFailed(response) {

                const { errors } = response.data;

                if (errors.status === 'requires_action') {
                    stripe.handleCardAction(errors.payment_intent_client_secret).then(function(result) {
                        if (result.error) {
                            showGlobalCardError('We were unable to process your payment. Please contact training@rheglobal.com.');
                            reject();
                        } else {
                            processBooking({...bookingValues, payment_intent_id: result.paymentIntent.id });
                        }
                    });
                }

                if (errors['processing_error'] === true) {
                    openProcessingErrorOverlay();
                    reject();
                }

                if (errors['payment']) {
                    showGlobalCardError(response.data.errors['payment']);
                    reject();
                }

                if (errors['event']) {
                    showGlobalEventError(response.data.errors['event']);
                    reject();
                }

                if (errors['delegates']) {
                    showGlobalDelegatesError(response.data.errors['delegates']);
                    reject();
                }
            }

            function bookingSuccess(total) {

                if( window.config.environment === 'production' ) {
                    try {
                        // round the total as GA event values need to be whole numbers
                        const newTotal = Math.round(total);

                        ReactGA.initialize('UA-85678412-1');

                        ReactGA.event({
                            category: 'User',
                            action: 'book',
                            value: newTotal
                        });

                    } catch (e) {
                        console.log("Error encountered when sending analytics: ", e.message);
                    }
                }

                showBookingSuccess();
                resolve();
            }

            return processBooking(bookingValues);
        });
    }

    _constructBookingValues(event, bookingValues, eLearningCourse) {

        // Prevent card details being sent to our server (Stripe handles all payment processing)
        const { card_details, ...formattedBookingValues } = bookingValues;

        return {
            event_id: event ? event.id : null,
            course_id: eLearningCourse ? eLearningCourse.id : null,
            is_elearning_booking: !!this.props.eLearningCourse,
            ...formattedBookingValues,
            attendees: this._formatAttendees(bookingValues.organisation_name, bookingValues.attendees)
        };
    }

    _formatAttendees(organisationName, attendees) {

        return attendees.map((attendee) => {

            // Units are only stored for front-end use
            const { units, ...formattedAttendee } = attendee;

            return {
                ...formattedAttendee,
                organisation: organisationName
            }
        });
    }

    _getCourseDetails() {
        if (this.props.event) {
            return this.props.event.course;
        } else if (this.props.eLearningCourse) {
            return this.props.eLearningCourse;
        }
    }

    _getBookingForms() {

        const bookingTitle = this.props.eLearningCourse ? 'E-Learning Booking' : 'Booking';

        let type,
            typeUrl,
            detailName,
            detailUrl;

        if(this.props.event){
            type = "Programme";
            typeUrl = '/events';
            detailName = this.props.event.course_name;
            detailUrl = '/events/' + this.props.event.id + '/' + this.props.event.course.slug;
        }
        if(this.props.eLearningCourse){
            type = "e-Learning";
            typeUrl = '/e-learning';
            detailName = this.props.eLearningCourse.name;
            detailUrl = '/courses/' + this.props.eLearningCourse.id + '/' + this.props.eLearningCourse.slug;
        }

        return (
            <article className={style['section-content']}>

                <BreadcrumbTrail
                    callback={crumbUrl => navigator.push(crumbUrl)}
                    className={style['rhe-breadcrumb']}
                    crumbs={[
                        {
                            title: type,
                            url: typeUrl
                        },
                        {
                            title: detailName,
                            url: detailUrl
                        },
                        {
                            title: 'Booking'
                        }
                    ]}
                />

                <article styleName="booking-panel">

                    <BookingBanner course={this._getCourseDetails()} />

                    <PageHeader title={bookingTitle} />

                    <Accordion theme={`booking`} accordionId={`organisation`}>

                        <AccordionTitle expanded={ this._isAccordionOpen('organisation') }>
                            1&nbsp;&nbsp;&nbsp;Organisation
                        </AccordionTitle>

                        <AccordionContent expanded={ this._isAccordionOpen('organisation') }>

                            <AccordionSection>
                                <BookingOrganisation />
                            </AccordionSection>

                        </AccordionContent>

                    </Accordion>

                    <Accordion theme={`booking`} accordionId={`delegates`}>

                        <AccordionTitle expanded={ this._isAccordionOpen('delegates') }>
                            2&nbsp;&nbsp;&nbsp;{(this.props.eLearningCourse && this.props.eLearningCourse.sorted_elearning_units.length > 0) ? 'Delegates and Modules' : 'Delegates'}
                        </AccordionTitle>

                        <AccordionContent expanded={ this._isAccordionOpen('delegates') }>

                            <BookingDelegates />

                        </AccordionContent>

                    </Accordion>

                    <Accordion theme={`booking`} accordionId={`payment`}>

                        <AccordionTitle expanded={ this._isAccordionOpen('payment') }>
                            3&nbsp;&nbsp;&nbsp;Payment
                        </AccordionTitle>

                        <AccordionContent expanded={ this._isAccordionOpen('payment') }>

                            <BookingPayment
                                onChangeCountry={ (id) => this.props.onChangeCountry(id) }
                            />

                        </AccordionContent>

                    </Accordion>

                    <Accordion theme={`booking`} accordionId={`confirmation`}>

                        <AccordionTitle expanded={ this._isAccordionOpen('confirmation') }>
                            4&nbsp;&nbsp;&nbsp;Confirmation
                        </AccordionTitle>

                        <AccordionContent expanded={ this._isAccordionOpen('confirmation') }>

                            <BookingConfirmation processBooking={ this._processBooking.bind(this) } includeVAT={ this.props.country && this.props.country.is_eu } />

                        </AccordionContent>

                    </Accordion>

                </article>

                <div className={ this._getOrderSummaryClassNames() }>

                    <OrderSummary event={ this.props.event }
                                  sector={ this.props.bookingValues.sector }
                                  attendees={ this.props.bookingValues.attendees }
                                  promotions={ this.props.promotionCodes }
                                  eLearningCourse={ this.props.eLearningCourse }
                                  usesCoursePrice={ this.props.override_price }
                                  coursePrice={ this.props.public_price }
                                  includeVAT={ (!this.props.country || (this.props.country && this.props.country.is_eu)) } />

                </div>

                <Overlay isOpen={ this.props.showProcessingErrorOverlay }
                         closeOverlay={ this.props.closeProcessingErrorOverlay }
                         title="Booking Failed"
                         size="small">
                    <p>
                        Your card was charged but something went wrong processing your order. Please do not re-attempt
                        booking and contact the RHE Training team on <a href="tel:01239 711793">01239 711793</a>
                        &nbsp;or email <a href="mailto:training@rheglobal.com">training@rheglobal.com</a>.
                    </p>

                    <Button onClick={this.props.closeProcessingErrorOverlay}>OK</Button>
                </Overlay>
            </article>
        );
    }

    _getDelegatePrice() {
        if (this.props.event && this.props.event.overridden_price) {
            return this.props.event.overridden_price;
        } else if (this.props.eLearningCourse && this.props.eLearningCourse.overridden_price) {
            return this.props.eLearningCourse.overridden_price;
        }

        if (this.props.bookingValues.sector === 'public') {
            if (this.props.event) return this.props.event.public_price;
            if (this.props.eLearningCourse) return this.props.eLearningCourse.public_price;
        } else if (this.props.bookingValues.sector === 'private') {
            if (this.props.event) return this.props.event.private_price;
            if (this.props.eLearningCourse) return this.props.eLearningCourse.private_price;
        }
    }

    _getCostBreakdown() {

        const options = {
            is_elearning_course: !!this.props.eLearningCourse,
            course: this.props.event ? this.props.event.course : this.props.eLearningCourse,
            delegates: this.props.bookingValues.attendees,
            full_delegate_price: this._getDelegatePrice(),
            promotion_codes: this.props.promotionCodes
        };

        return costCalculator.calculate(options);
    }

    _handleScriptInject({ scriptTags }) {
        if (scriptTags) {
            const scriptTag = scriptTags[1]; // There are 2 scripts being loaded but we only need to run something after the first one is in there
            scriptTag.onload = () => {
                window.stripe = Stripe(window.config.stripePublishableKey);
                Stripe.setPublishableKey(window.config.stripePublishableKey);
            };
        }
    }

    render() {

        return (
            <div styleName="booking-container">
                <Helmet
                    script={[
                        { src: "https://js.stripe.com/v2/" },
                        { src: "https://js.stripe.com/v3/" }
                    ]}
                    onChangeClientState={(newState, addedTags) => this._handleScriptInject(addedTags)}
                />

                <Helmet title="Booking" />

                { this.props.isShowingBookingSuccess ? <BookingSuccess /> : this._getBookingForms() }

            </div>
        );
    }
}

function mapStateToProps(state) {

    return state.payment;
}

function mapDispatchToProps(dispatch) {

    return {
        openProcessingErrorOverlay() {

            dispatch(paymentActions.updateProcessingErrorVisibility(true));
        },
        closeProcessingErrorOverlay() {

            dispatch(paymentActions.updateProcessingErrorVisibility(false));
        },
        resetPaymentPage() {

            dispatch(paymentActions.resetPaymentPage());
        },
        hideGlobalDelegatesError() {

            dispatch(paymentActions.hideGlobalDelegatesError());
        },
        hideGlobalCardError() {

            dispatch(paymentActions.hideGlobalCardError());
        },
        hideGlobalEventError() {

            dispatch(paymentActions.hideGlobalEventError());
        },
        showGlobalDelegatesError(errorMessage) {

            dispatch(paymentActions.showGlobalDelegatesError(errorMessage));
        },
        showGlobalEventError(errorMessage) {

            dispatch(paymentActions.showGlobalEventError(errorMessage));
        },
        showGlobalCardError(errorMessage) {

            dispatch(paymentActions.showGlobalCardError(errorMessage));
        },
        showBookingSuccess() {

            dispatch(paymentActions.showBookingSuccess());
        },
        refreshEvent(eventId) {

            dispatch(paymentActions.refreshPaymentEvent(eventId));
        },
        refreshELearningCourse(eLearningCourseId) {

            dispatch(paymentActions.refreshPaymentELearningCourse(eLearningCourseId));
        },
        onChangeCountry(id) {

            dispatch(paymentActions.getCountry(id));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(BookingPage, style));


// WEBPACK FOOTER //
// ./components/BookingPage/index.js